// extracted by mini-css-extract-plugin
export default {"mCard":"kE-z","image":"lE-z","imageNoBackground":"mE-z","imageHasCategory":"nE-z","fullWidth":"oE-z"};